const sharedSettings = {
  name: { editable: true, type: 'input', rules: [{ required: true }] },

  created_at: { hidden: true },
  updated_at: { hidden: true },

  area_name: { hidden: true },
  area_user_type: { hidden: true },
}

export const settings = {
  id: { label: "ID" },
  ...sharedSettings
};

export const initialSettings = {
  id: { hidden: true },
  ...sharedSettings,
}

export const initialValues = {
  name: "",
};
